export default __webpack_public_path__ + "static/media/CoupleIMG.b416de12.JPG";